import React from 'react'

function CarouselPics() {
	return (
		<div>
			<div id="slider">
				<figure>
					<div className='pics'>
						<img src="/bg pics/carousel1.jpg" alt='pic1' />
					</div>
					<div className='pics'>
						<img src="/bg pics/carousel2.jpg" alt='pic2' />
					</div>
					<div className='pics'>
						<img src="/bg pics/carousel3.jpg" alt='pic3' />
					</div>
					<div className='pics'>
						<img src="/bg pics/carousel4.jpg" alt='pic4' />
					</div>
					<div className='pics'>
						<img src="/bg pics/carousel2.jpg" alt='pic5' />
					</div>
				</figure>
			</div>
		</div>
	)
}

export default CarouselPics;
